export default __webpack_public_path__ + "0f3344826f068df1cb9dd2b009dc9890.png";